<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :rowSelection="computedSelect"
        :loading="loading"
      >
        <template slot="name" slot-scope="name">
          <div>
            <div class="font-weight-bold">{{name}}</div>
            <!-- <div class="text-gray-4">{{user.position}}</div> -->
          </div>
        </template>
        <template slot="type" slot-scope="type">
          <!-- <span class="font-weight-bold">{{ type === 1 ? 'One Time' : type === 2 ? 'Recurring' : '' }}</span> -->
          <span class="font-weight-bold">{{ find(feeTypes, { 'value': type }).name }}</span>
        </template>
        <template slot="fine_mode" slot-scope="fine_mode">
          <span >{{ find(lateFeeFineMode, { 'value': fine_mode }).name }}</span>
        </template>
        <template slot="fine_type" slot-scope="fine_type">
          <span >{{ find(lateFeeFineType, { 'value': fine_type }).name }}</span>
        </template>
        <template slot="name" slot-scope="fine">
          <div>
            <div class="font-weight-bold">{{fine}}</div>
            <!-- <div class="text-gray-4">{{user.position}}</div> -->
          </div>
        </template>
        <template slot="action" slot-scope="text, record">
          <div class="text-nowrap">
            <!-- Edit -->
            <a href="javascript:;" v-if="rolesetting.editable" class="btn btn-sm btn-light btn-with-addon mr-2"
              @click="showEditModal(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-edit" />
              </span>
              <!-- <edit-fee ref="editFee" @edited="handleEdited"/> -->
              Edit
            </a>
            <a-tooltip placement="top">
              <template slot="title" v-if="record.class_fees_count !== 0">
                <span>Cannot Delete. Related data present under this record!</span>
              </template>
              <span>
                <!-- Delete -->
                <a href="javascript:;" v-if="rolesetting.deletable" class="btn btn-sm btn-danger btn-with-addon"
                  @click="onDelete(record)" :class="record.class_fees_count !== 0 ? 'disabled' : ''"
                >
                  <span class="btn-addon">
                    <i class="btn-addon-icon fe fe-trash" />
                  </span>
                  Delete
                </a>
              </span>
            </a-tooltip>
          </div>
        </template>
      </a-table>
    </div>

    <edit-fee ref="editFee" @edited="handleEdited"/>
  </div>
</template>
<script>
import EditFee from '@/components/fee/Forms/Edit/index'
import { feeTypes, lateFeeFineMode, lateFeeFineType } from '@/services/globaldata'
import { find } from 'lodash'

const columns = [
  {
    title: 'Fees',
    dataIndex: 'name',
    className: 'text-left text-gray-6',
    scopedSlots: { customRender: 'name' },
    sorter: (a, b) => a.name.localeCompare(b.name),
  },
  {
    title: 'Category',
    dataIndex: 'category',
    key: 'category',
    sorter: (a, b) => {
      if (!a.category) return -1
      if (!b.category) return 1
      return a.category.localeCompare(b.category)
    },
  },
  {
    title: 'Type',
    dataIndex: 'type',
    key: 'type',
    scopedSlots: { customRender: 'type' },
    sorter: (a, b) => a.type - b.type,
  },
  {
    title: 'Fine Mode',
    dataIndex: 'fine_mode',
    key: 'fine_mode',
    scopedSlots: { customRender: 'fine_mode' },
    sorter: (a, b) => a.type - b.type,
  },
  {
    title: 'Fine Type',
    dataIndex: 'fine_type',
    key: 'fine_type',
    scopedSlots: { customRender: 'fine_type' },
    sorter: (a, b) => a.type - b.type,
  },
  {
    title: 'Fine',
    dataIndex: 'fine',
    key: 'fine',
    scopedSlots: { customRender: 'fine' },
    sorter: (a, b) => a.type - b.type,
  },
  {
    title: 'Actions',
    dataIndex: 'action',
    className: 'text-right',
    scopedSlots: { customRender: 'action' },
  },
]

export default {

  name: 'FeesTable',
  components: {
    EditFee,
  },
  props: {
    select: Boolean,
    loading: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
    rolesetting: { type: Object },
  },
  data: function() {
    return {
      columns,
      selectedRowKeys: [],
      feeTypes,
      lateFeeFineMode,
      lateFeeFineType,
    }
  },
  computed: {
    computedSelect: function() {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  methods: {
    find,
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    showEditModal: function(record) {
      // this.$refs.editFee.showModal(record.id)
      this.$eventBus.$emit('openFeeEditModal', record.id)
    },
    handleEdited: function () {
      this.$emit('updateTable')
    },
    onDelete: function(record) {
      this.$confirm({
        title: 'Are you sure delete this plan?',
        content: `Plan ${record.name} will be deleted if you click Yes`,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/fee/' + record.id)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: record.name + ' has been deleted.',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>
